(function () {
    'use strict';
    var controllerId = 'fatturaPaAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', fatturaPaAddFn]);

    function fatturaPaAddFn($scope, $uibModalInstance, datacontext) {
        $scope.item = {};
        $scope.item.Importo = 0;
        getBuoni();

        //DatePicker (gestione del calendario)
        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            $scope.opened = !$scope.opened;
        };

        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.format = 'dd/MM/yyyy';

        $scope.ok = function (isValid) {
            if (isValid) {
                var buoniList = [];
                $("input:checkbox[name=buono]:checked").each(function () {
                    buoniList.push($(this).val());
                });
                $scope.item.BuoniDaFatturare = buoniList;
                var result = addItem($scope.item);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getBuoni() {
            datacontext.fatturaPa_getBuoniDaFatturare().then(function (data) {
                $scope.buoni = data;
            });
        }

        $scope.buono_click = function (id, importo) {            
            if ($("#buono_" + id).prop("checked"))
                $scope.item.Importo += importo;
            else
                $scope.item.Importo -= importo;
        }

        function addItem(item) {
            return datacontext.fatturaPa_add(item).then(function (data) {
                if (!data) return null;

                return data;
            });
        }        
    }
})();